import styled from "@emotion/styled";

const PageWrapper = styled.div`
    min-height: 100vh;
  background-color: #000 !important; 

`;

export { PageWrapper }
